import { render, staticRenderFns } from "./FabricDimensionPriceDetails.vue?vue&type=template&id=4256be2a&scoped=true"
import script from "./FabricDimensionPriceDetails.vue?vue&type=script&lang=js"
export * from "./FabricDimensionPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./FabricDimensionPriceDetails.vue?vue&type=style&index=0&id=4256be2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4256be2a",
  null
  
)

export default component.exports